export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  receivable: 'receivable',
  payable: 'payable',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  receivable: { create: 'create', adjust: 'adjust' },
  payable: { create: 'create', adjust: 'adjust' },
};
